module.exports = __webpack_public_path__ + "static/media/icon_chat_darkgrey.966fb1f2.svg";